import styled from 'styled-components';

// 버튼들을 감싸는 컨테이너
export const FloatingButtonsContainer = styled.div`
  position: fixed;
  bottom: ${({ theme }) => `calc(${theme.config.navigationHeight} + 20px)`};
  bottom: ${({ theme }) => `calc(${theme.config.navigationHeight} + 20px)`};
  right: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1000;
`;

// 개별 버튼 스타일
export const FloatingButton = styled.a`
  background-color: #ffcd00; /* 기본 버튼 색상 (카카오톡) */
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
  text-decoration: none;

  &.tel {
    background-color: #fff; /* 전화 버튼 색상 */
  }

  &.kakao {
    background-color: #ffcd00; /* 카카오톡 버튼 색상 */
  }

  img {
    width: 100%;
    object-fit: contain; /* 아이콘 비율 유지 */
  }
`;

